<template>
  <div v-if="authenticated" class="branding-restore-control">
    <span
      class="branding-restore-status"
      :class="customized ? 'text-primary' : 'text-success'"
    >
      <b-icon
        :icon="customized ? 'brush' : 'check-circle-fill'"
        class="mr-1"
      />
      {{ customized ? 'Personalizado' : 'Predeterminado' }}
    </span>

    <b-button
      size="sm"
      variant="outline-secondary"
      :disabled="restoring"
      @click="confirmRestore"
    >
      <b-spinner v-if="restoring" small class="mr-1" />
      <b-icon v-else icon="arrow-counterclockwise" class="mr-1" />
      Restaurar predeterminado
    </b-button>
  </div>
</template>

<script>
import Error from '@/handler/error'
import Session from '@/handler/session'
import serviceAPI from './services'

export default {
  name: 'BrandingRestoreControl',
  props: {
    target: {
      type: String,
      required: true,
      validator: value => ['logo', 'favicon', 'image_login'].indexOf(value) !== -1,
    },
    customized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      restoring: false,
    }
  },
  computed: {
    authenticated() {
      return !!Session.getSession().auth
    },
    targetCopy() {
      const copies = {
        logo: {
          article: 'el',
          label: 'logo',
          success: 'Logo restaurado',
        },
        favicon: {
          article: 'el',
          label: 'ícono',
          success: 'Ícono restaurado',
        },
        image_login: {
          article: 'la',
          label: 'imagen de inicio de sesión',
          success: 'Imagen de inicio de sesión restaurada',
        },
      }

      return copies[this.target]
    },
  },
  methods: {
    confirmRestore() {
      this.$bvModal.msgBoxConfirm(
        `¿Desea restaurar ${this.targetCopy.article} ${this.targetCopy.label} original de Zyncro?`,
        {
          title: 'Restaurar imagen predeterminada',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'warning',
          okTitle: 'Restaurar',
          cancelVariant: 'outline-secondary',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          hideHeaderClose: false,
        }
      )
      .then(confirmed => {
        if (confirmed) this.restore()
      })
    },
    restore() {
      this.restoring = true

      serviceAPI.restaurarBranding(this.target)
      .then(response => {
        const data = response.data
        Session.setSessionSettings(data)
        this.$emit('restored', { target: this.target, data })
        this.$awn.success(this.targetCopy.success)
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error))
      })
      .finally(() => {
        this.restoring = false
      })
    },
  },
}
</script>

<style scoped>
.branding-restore-control {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e4e7ea;
}

.branding-restore-status {
  display: inline-flex;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 600;
}
</style>
